/** Un refresco que falló con datos ya en pantalla: se dejan los de antes y se dice (como en WhatsApp). */
export function ErrorRefresco({ error, onReintentar }: { error: string; onReintentar: () => void }) {
  return (
    <p className="text-xs text-amber-700" role="status">
      No pudimos actualizar: {error} Lo que ves es lo último que trajimos.{" "}
      <button type="button" onClick={onReintentar} className="font-semibold underline">Reintentar</button>
    </p>
  );
}

export default ErrorRefresco;
